<template>
  <div class="m-page">
    <section class="m-hero">
      <div class="m-hero-card">
        <div class="m-hero-content">
          <div class="m-hero-title">装修上化化</div>
          <h1 class="m-hero-title">您的放心之选</h1>
          <p class="m-hero-subtitle">找设计、找师傅、找装企，服务至满意为止。</p>
          <button class="m-hero-cta" type="button" @click="openQrModal">
            <img src="https://obs.huahuaeco.com/official/home/tryItNow.png" alt="立即体验" />
          </button>
        </div>
      </div>
    </section>

    <nav class="m-anchor-nav" aria-label="首页核心保障">
      <button
        v-for="item in navList"
        :key="item.anchorId"
        class="m-anchor-item"
        type="button"
        @click="onNavClick(item.anchorId)"
      >
        <img class="m-anchor-icon" :src="item.icon" :alt="item.label" />
        <span class="m-anchor-label">{{ item.label }}</span>
      </button>
    </nav>

    <section
      v-for="section in featureSections"
      :id="section.id"
      :key="section.id"
      class="m-feature-section"
    >
      <h2 class="m-feature-title">{{ section.title }}</h2>
      <div class="m-feature-card">
        <div class="m-feature-copy">
          <p
            v-for="(line, index) in section.desc"
            :key="line"
            :class="{ primary: index === 0 }"
          >
            {{ line }}
          </p>
        </div>
        <img class="m-feature-img" :class="section.imgClass" :src="section.img" :alt="section.title" />
      </div>
    </section>

    <section id="img-6" class="m-flow-section">
      <h2>在线交易流程</h2>
      <p>两种下单模式随心选，均可享平台保障</p>
      <div class="m-flow-toggle" aria-label="切换下单模式">
        <button
          :class="['m-flow-btn', { active: flowActive === 'left' }]"
          type="button"
          @click="setFlow('left')"
        >
          比价下单模式
        </button>
        <button
          :class="['m-flow-btn', { active: flowActive === 'right' }]"
          type="button"
          @click="setFlow('right')"
        >
          邀约下单模式
        </button>
      </div>
      <div class="m-flow-scroller">
        <img
          class="m-flow-img"
          :src="flowActive === 'left' ? flowImgs.left : flowImgs.right"
          :alt="flowActive === 'left' ? '比价下单模式流程' : '邀约下单模式流程'"
        />
      </div>
    </section>

    <section id="img-7" class="m-brands-section">
      <h2>平台合作伙伴</h2>
      <img src="https://obs.huahuaeco.com/official/HomeM/huahuaCompanyPartner.png" alt="平台合作伙伴" />
    </section>

    <section id="img-8" class="m-experience-section">
      <h2>立即体验</h2>
      <p>我们致力于服务至业主满意为止，不负每个客户的信任</p>
      <img src="https://obs.huahuaeco.com/official/qrcode.png" alt="化化平台二维码" />
    </section>

    <section id="img-9" class="m-media-section">
      <h2>媒体报道</h2>
      <div
        class="m-media-carousel"
        @touchstart.passive="handleMediaTouchStart"
        @touchend="handleMediaTouchEnd"
      >
        <div class="m-media-viewport">
          <div class="m-media-track" :style="{ transform: `translateX(-${mediaActiveIndex * 100}%)` }">
            <div v-for="(item, index) in mediaList" :key="item.href" class="m-media-slide">
              <a
                class="m-media-card"
                :href="item.href"
                target="_blank"
                rel="noopener noreferrer"
                @click="handleMediaClick($event, index)"
              >
                <img :src="item.logo" :alt="item.name" />
                <p>{{ item.desc }}</p>
              </a>
            </div>
          </div>
        </div>

        <div class="m-media-dots" aria-label="媒体报道切换">
          <button
            v-for="(item, index) in mediaList"
            :key="item.href"
            :class="['m-media-dot', { active: mediaActiveIndex === index }]"
            type="button"
            :aria-label="`查看第${index + 1}条媒体报道`"
            :aria-current="mediaActiveIndex === index ? 'true' : 'false'"
            @click="setMediaActive(index)"
          ></button>
        </div>
      </div>
    </section>

    <div v-if="showQrModal" class="m-qr-overlay" @click.self="closeQrModal">
      <div class="m-qr-dialog" role="dialog" aria-modal="true" aria-label="小程序二维码">
        <button class="m-qr-close" type="button" aria-label="关闭二维码" @click="closeQrModal">×</button>
        <img :src="qrCodeUrl" alt="化化小程序二维码" />
      </div>
    </div>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../../utils/page-head'
import SeoStaticImages from '../../components/SeoStaticImages.vue'

export default {
  name: 'HomeMobilePage',
  components: {
    SeoStaticImages
  },
  setup() {
    useHead(getPageHead('home', 'https://www.huahuaeco.com/'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/home/home.png',
        'https://obs.huahuaeco.com/official/homeBg1.png',
        'https://obs.huahuaeco.com/official/HomeM/comparePriceMobile.png',
        'https://obs.huahuaeco.com/official/HomeM/directOrderMobile.png',
        'https://obs.huahuaeco.com/official/qrcode.png'
      ],
      navList: [
        { label: '先装后付', icon: 'https://obs.huahuaeco.com/official/HomeM/icon1.png', anchorId: 'img-1' },
        { label: '信息透明', icon: 'https://obs.huahuaeco.com/official/HomeM/icon2.png', anchorId: 'img-2' },
        { label: '在线履约', icon: 'https://obs.huahuaeco.com/official/HomeM/icon3.png', anchorId: 'img-3' },
        { label: '售后保障', icon: 'https://obs.huahuaeco.com/official/HomeM/icon4.png', anchorId: 'img-4' },
        { label: '平台托底', icon: 'https://obs.huahuaeco.com/official/HomeM/icon5.png', anchorId: 'img-5' }
      ],
      featureSections: [
        {
          id: 'img-1',
          title: '开工0预付，装修更主动',
          desc: ['100%装修款由平台托管，按阶段验收、满意再付款。', '用资金保障您的绝对话语权，让装修全程安心无忧。'],
          img: 'https://obs.huahuaeco.com/official/home1.png',
          imgClass: 'is-home1'
        },
        {
          id: 'img-2',
          title: '口碑全公开，好坏不隐藏',
          desc: ['每一位服务方的历史项目评价、优缺点均完整展示。', '为您提供最真实的“避坑指南”与决策参考，选择从未如此清晰。'],
          img: 'https://obs.huahuaeco.com/official/home2.png'
        },
        {
          id: 'img-3',
          title: '告别装修扯皮，把“省心”装回家',
          desc: ['交易在线、过程透明、信息可查。', '平台作为您最可靠的后盾。', '让纠纷处理变得轻松简单，装修全程省心又省力。'],
          img: 'https://obs.huahuaeco.com/official/home3.png'
        },
        {
          id: 'img-4',
          title: '平台强力保障，售后问题不用愁',
          desc: ['服务方提供的售后服务，不得低于国家标准，', '未履行时将受到平台严厉处罚，', '并补偿业主损失，彻底解决您的后顾之忧'],
          img: 'https://obs.huahuaeco.com/official/home4.png'
        },
        {
          id: 'img-41',
          title: '平台全程守护，交易更安心',
          desc: ['从签约到竣工，平台作为中立的守护者，', '全程见证并监督每一环节。', '我们确保一切按约定执行，始终站在您这边，', '为顺利完工保驾护航。'],
          img: 'https://obs.huahuaeco.com/official/home41.png',
          imgClass: 'is-home41'
        },
        {
          id: 'img-5',
          title: '平台托底保障，服务至满意为止',
          desc: ['一旦您与服务方合作破裂且无法协商，', '可申请平台托底服务，', '平台自营团队将立即接手，继续施工至您满意为止'],
          img: 'https://obs.huahuaeco.com/official/home5.png'
        }
      ],
      flowActive: 'left',
      flowImgs: {
        left: 'https://obs.huahuaeco.com/official/HomeM/comparePriceMobile.png',
        right: 'https://obs.huahuaeco.com/official/HomeM/directOrderMobile.png'
      },
      mediaList: [
        {
          name: '凤凰网',
          logo: 'https://obs.huahuaeco.com/official/media1.png',
          href: 'https://sz.ifeng.com/c/8tSo7hhnMqv',
          desc: '从六平方柜台到“化化”革命一记一个老工程人的“自寻烦恼”'
        },
        {
          name: '腾讯家居',
          logo: 'https://obs.huahuaeco.com/official/media2.png',
          href: 'https://www.jia360.com/new/257003.html',
          desc: '化化装修平台和传统装修平台有什么区别？一张表看懂'
        },
        {
          name: '新浪看点',
          logo: 'https://obs.huahuaeco.com/official/media3.png',
          href: 'https://k.sina.com.cn/article_7763523677_1cebdf85d00101inqi.html?kdurlshow=1',
          desc: '家装行业现“先装后付”新模式：第三方平台尝试破解信任困局'
        }
      ],
      mediaActiveIndex: 0,
      mediaTimer: null,
      mediaTouchStartX: 0,
      mediaTouchStartY: 0,
      mediaDidSwipe: false,
      qrCodeUrl: 'https://obs.huahuaeco.com/official/qrcode.png',
      showQrModal: false
    }
  },
  methods: {
    setFlow(side) {
      this.flowActive = side
    },
    setMediaActive(index) {
      const total = this.mediaList.length
      if (!total) return
      this.mediaActiveIndex = (index + total) % total
      this.restartMediaAutoPlay()
    },
    nextMedia() {
      this.setMediaActive(this.mediaActiveIndex + 1)
    },
    prevMedia() {
      this.setMediaActive(this.mediaActiveIndex - 1)
    },
    startMediaAutoPlay() {
      if (this.mediaList.length <= 1 || this.mediaTimer) return
      this.mediaTimer = window.setInterval(() => {
        this.mediaActiveIndex = (this.mediaActiveIndex + 1) % this.mediaList.length
      }, 4200)
    },
    stopMediaAutoPlay() {
      if (!this.mediaTimer) return
      window.clearInterval(this.mediaTimer)
      this.mediaTimer = null
    },
    restartMediaAutoPlay() {
      this.stopMediaAutoPlay()
      this.startMediaAutoPlay()
    },
    handleMediaTouchStart(event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      this.mediaTouchStartX = touch.clientX
      this.mediaTouchStartY = touch.clientY
      this.mediaDidSwipe = false
      this.stopMediaAutoPlay()
    },
    handleMediaTouchEnd(event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) {
        this.startMediaAutoPlay()
        return
      }

      const deltaX = touch.clientX - this.mediaTouchStartX
      const deltaY = touch.clientY - this.mediaTouchStartY
      if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
        this.mediaDidSwipe = true
        if (deltaX < 0) {
          this.nextMedia()
        } else {
          this.prevMedia()
        }
        window.setTimeout(() => {
          this.mediaDidSwipe = false
        }, 80)
      } else {
        this.startMediaAutoPlay()
      }
    },
    handleMediaClick(event, index) {
      if (this.mediaDidSwipe) {
        event.preventDefault()
        return
      }
      this.setMediaActive(index)
    },
    onNavClick(id) {
      this.scrollTo(id)
    },
    scrollTo(id) {
      const el = document.getElementById(id)
      if (!el) return

      const header = document.querySelector('.m-header')
      const headerHeight = header ? header.getBoundingClientRect().height : 0
      const target = el.querySelector('h2') || el
      const topGap = 16
      const y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - topGap
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' })
    },
    openQrModal() {
      this.showQrModal = true
    },
    closeQrModal() {
      this.showQrModal = false
    }
  },
  mounted() {
    if (window.location.hash && window.location.hash.startsWith('#img-')) {
      try { history.replaceState(null, '', window.location.pathname + window.location.search) } catch (e) {}
      window.scrollTo({ top: 0 })
    }
    this.startMediaAutoPlay()
  },
  beforeUnmount() {
    this.stopMediaAutoPlay()
  }
}
</script>

<style scoped lang="scss">
.m-page {
  padding-top: calc(88 * var(--rpx));
  background: #f4f7fb;
  min-height: 100vh;
  overflow: hidden;
}

.m-hero {
  padding: calc(32 * var(--rpx));
  background: #fff;
}

.m-hero-card {
  min-height: calc(480 * var(--rpx));
  display: flex;
  align-items: flex-start;
  padding: calc(78 * var(--rpx)) calc(48 * var(--rpx)) calc(48 * var(--rpx));
  overflow: hidden;
  border-radius: calc(32 * var(--rpx));
  background-image: url('https://obs.huahuaeco.com/official/home/home.png');
  background-size: cover;
  background-position: center;
}

.m-hero-content {
  width: min(100%, calc(560 * var(--rpx)));
}

.m-hero-title {
  margin: 0;
  color: #262626;
  font-size: calc(48 * var(--rpx));
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: calc(4 * var(--rpx));
}

.m-hero-subtitle {
  width: calc(370 * var(--rpx));
  max-width: 100%;
  margin: calc(28 * var(--rpx)) 0 calc(28 * var(--rpx));
  color: #595959;
  font-size: calc(28 * var(--rpx));
  line-height: 1.65;
}

.m-hero-cta {
  display: inline-flex;
  width: calc(300 * var(--rpx));
  height: calc(60 * var(--rpx));
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.m-anchor-nav {
  display: flex;
  justify-content: space-between;
  padding: calc(42 * var(--rpx)) calc(32 * var(--rpx)) calc(36 * var(--rpx));
  background: #fff;
}

.m-anchor-item {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #262626;
  text-align: center;
  cursor: pointer;
}

.m-anchor-icon {
  display: block;
  width: calc(72 * var(--rpx));
  height: calc(72 * var(--rpx));
  margin: 0 auto calc(16 * var(--rpx));
  object-fit: contain;
}

.m-anchor-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262626;
  font-size: calc(28 * var(--rpx));
  font-weight: 400;
  line-height: 1.35;
}

.m-feature-section {
  padding: calc(62 * var(--rpx)) calc(32 * var(--rpx)) 0;
  background: #f4f7fb;
  scroll-margin-top: calc(96 * var(--rpx));
}

.m-feature-title {
  margin: 0;
  color: #262626;
  text-align: center;
  font-size: calc(42 * var(--rpx));
  font-weight: 700;
  line-height: 1.25;
}

.m-feature-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(20 * var(--rpx));
  min-height: calc(212 * var(--rpx));
  margin-top: calc(34 * var(--rpx));
  padding: calc(34 * var(--rpx)) calc(30 * var(--rpx));
  border-radius: calc(28 * var(--rpx));
  background: #fff;
  overflow: hidden;
}

.m-feature-copy {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;

  p {
    margin: calc(24 * var(--rpx)) 0 0;
    color: #8c8c8c;
    font-size: calc(24 * var(--rpx));
    line-height: 1.68;
  }

  p.primary {
    margin-top: 0;
    color: #262626;
    font-weight: 600;
    line-height: 1.5;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.m-feature-img {
  flex: 0 0 calc(230 * var(--rpx));
  width: calc(230 * var(--rpx));
  max-width: 38%;
  max-height: calc(170 * var(--rpx));
  object-fit: contain;
}

.m-feature-img.is-home1,
.m-feature-img.is-home41 {
  flex-basis: calc(245 * var(--rpx));
  width: calc(245 * var(--rpx));
  max-height: calc(180 * var(--rpx));
}

.m-flow-section,
.m-brands-section,
.m-experience-section,
.m-media-section {
  scroll-margin-top: calc(96 * var(--rpx));
}

.m-flow-section {
  padding: calc(72 * var(--rpx)) 0 calc(72 * var(--rpx));
  background: #f4f7fb;
  text-align: center;
}

.m-flow-section h2,
.m-brands-section h2,
.m-experience-section h2,
.m-media-section h2 {
  margin: 0;
  color: #262626;
  font-size: calc(42 * var(--rpx));
  font-weight: 600;
  line-height: 1.25;
}

.m-flow-section p,
.m-experience-section p {
  margin: calc(20 * var(--rpx)) auto 0;
  width: calc(620 * var(--rpx));
  max-width: calc(100% - 64 * var(--rpx));
  color: #595959;
  font-size: calc(28 * var(--rpx));
  line-height: 1.6;
}

.m-flow-toggle {
  display: inline-flex;
  margin-top: calc(32 * var(--rpx));
  padding: calc(6 * var(--rpx));
  border-radius: calc(999 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(12 * var(--rpx)) calc(30 * var(--rpx)) rgba(22, 95, 230, 0.1);
}

.m-flow-btn {
  width: calc(220 * var(--rpx));
  height: calc(64 * var(--rpx));
  border: 0;
  border-radius: calc(999 * var(--rpx));
  background: transparent;
  color: #262626;
  font-size: calc(26 * var(--rpx));
  font-weight: 500;
  white-space: nowrap;
}

.m-flow-btn.active {
  color: #fff;
  background: linear-gradient(90deg, #5bf7fe, #198cfe);
  box-shadow: 0 calc(8 * var(--rpx)) calc(18 * var(--rpx)) rgba(25, 140, 254, 0.25);
}

.m-flow-scroller {
  margin-top: calc(50 * var(--rpx));
  padding: 0 calc(32 * var(--rpx)) calc(18 * var(--rpx));
  overflow: hidden;
}

.m-flow-img {
  display: block;
  width: 100%;
  max-width: calc(686 * var(--rpx));
  height: auto;
  margin: 0 auto;
  object-fit: contain;
}

.m-brands-section {
  padding: calc(72 * var(--rpx)) calc(32 * var(--rpx)) calc(80 * var(--rpx));
  background: url('https://obs.huahuaeco.com/official/homeBg1.png') center / cover no-repeat;
  text-align: center;

  img {
    display: block;
    width: 100%;
    margin: calc(56 * var(--rpx)) auto 0;
    height: auto;
  }
}

.m-experience-section {
  padding: calc(72 * var(--rpx)) calc(40 * var(--rpx)) calc(88 * var(--rpx));
  background: #fff;
  text-align: center;

  img {
    display: block;
    width: min(calc(520 * var(--rpx)), 78vw);
    margin: calc(60 * var(--rpx)) auto 0;
    height: auto;
  }
}

.m-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--rpx));
  background: rgba(15, 23, 42, 0.42);
}

.m-qr-dialog {
  position: relative;
  width: min(calc(520 * var(--rpx)), 82vw);
  padding: calc(40 * var(--rpx));
  border-radius: calc(18 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(24 * var(--rpx)) calc(70 * var(--rpx)) rgba(15, 23, 42, 0.22);

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.m-qr-close {
  position: absolute;
  top: calc(10 * var(--rpx));
  right: calc(14 * var(--rpx));
  width: calc(46 * var(--rpx));
  height: calc(46 * var(--rpx));
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #8c8c8c;
  font-size: calc(38 * var(--rpx));
  line-height: calc(46 * var(--rpx));
}

.m-media-section {
  padding: calc(72 * var(--rpx)) calc(32 * var(--rpx)) calc(80 * var(--rpx));
  background:
    radial-gradient(circle at top, rgba(228, 237, 247, 0.92) 0%, rgba(245, 248, 252, 0.94) 34%, #ffffff 82%),
    linear-gradient(180deg, #f5f8fc 0%, #ffffff 100%);
  text-align: center;
}

.m-media-carousel {
  margin-top: calc(56 * var(--rpx));
  touch-action: pan-y;
}

.m-media-viewport {
  overflow: hidden;
}

.m-media-track {
  display: flex;
  transition: transform 0.36s ease;
  will-change: transform;
}

.m-media-slide {
  flex: 0 0 100%;
  padding: 0 calc(10 * var(--rpx)) calc(8 * var(--rpx));
}

.m-media-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(260 * var(--rpx));
  padding: calc(44 * var(--rpx)) calc(36 * var(--rpx)) calc(38 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 calc(16 * var(--rpx)) calc(48 * var(--rpx)) rgba(56, 89, 126, 0.08);
  text-decoration: none;

  img {
    display: block;
    max-width: calc(260 * var(--rpx));
    max-height: calc(58 * var(--rpx));
    width: auto;
    height: auto;
    margin: 0 auto;
    object-fit: contain;
  }

  p {
    margin: calc(28 * var(--rpx)) auto 0;
    color: #262626;
    font-size: calc(28 * var(--rpx));
    line-height: 1.6;
  }
}

.m-media-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(14 * var(--rpx));
  margin-top: calc(28 * var(--rpx));
}

.m-media-dot {
  width: calc(14 * var(--rpx));
  height: calc(14 * var(--rpx));
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #d7e0ea;
  transition: width 0.24s ease, background 0.24s ease;
}

.m-media-dot.active {
  width: calc(36 * var(--rpx));
  background: #198cfe;
}

@media (min-width: 560px) {
  .m-feature-section {
    padding-left: calc(56 * var(--rpx));
    padding-right: calc(56 * var(--rpx));
  }

  .m-feature-img {
    max-height: calc(190 * var(--rpx));
  }
}
</style>
